// extracted by mini-css-extract-plugin
export default {"error_block":"loading-error-LoadingErrorBanner__error_block--36B8-","error_heading":"loading-error-LoadingErrorBanner__error_heading--21NVA"};